import * as t from "io-ts";

export const RouteLegCodec = t.intersection([
  t.type({
    distanceMeters: t.number,
    timeMillis: t.number,
  }),
  t.partial({}),
]);

export type RouteLeg = t.TypeOf<typeof RouteLegCodec>;
